import { createSlice } from '@reduxjs/toolkit';
import {
  createSupplierCreditApplicationTemplateExtraReducer,
  getCreditApplicationTemplatesExtraReducer,
  getCreditApplicationTemplateExtraReducer,
  updateCreditApplicationTemplateExtraReducer,
} from '../reducers/creditApplicationTemplatesReducers';
import { CreditApplicationTemplate } from '@dill/dill-shared';

export interface CreditApplicationTemplatesInitialState {
  loadingList: string[];
  creditApplicationTemplates: CreditApplicationTemplate[];
  supplierCreditApplicationTemplates: CreditApplicationTemplate[];
  creditApplicationTemplatesByAdmin: CreditApplicationTemplate[];
  creditApplicationTemplate: CreditApplicationTemplate | null;
}

const initialState: CreditApplicationTemplatesInitialState = {
  loadingList: [],
  creditApplicationTemplates: [],
  supplierCreditApplicationTemplates: [],
  creditApplicationTemplatesByAdmin: [],
  creditApplicationTemplate: null,
};

export const creditApplicationTemplatesSlice = createSlice({
  name: 'creditApplicationTemplates',
  initialState,
  reducers: {
    resetCreditApplicationTemplatesRootState: () => initialState,
  },
  extraReducers(builder) {
    getCreditApplicationTemplatesExtraReducer(builder);
    createSupplierCreditApplicationTemplateExtraReducer(builder);
    getCreditApplicationTemplateExtraReducer(builder);
    updateCreditApplicationTemplateExtraReducer(builder);
  },
});

export const { resetCreditApplicationTemplatesRootState } = creditApplicationTemplatesSlice.actions;
